import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-community-product',
  templateUrl: './community-product.component.html',
  styleUrls: ['./community-product.component.scss']
})
export class CommunityProductComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
